<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3 9.801C3.005 4.943 7.032 1.005 12 1c4.968.005 8.995 3.943 9 8.801 0 6.069-6.158 11.581-8.129 13.11a1.436 1.436 0 0 1-1.818 0C9.158 21.381 3 15.87 3 9.8Zm4.578-.21a4.548 4.548 0 1 0 9.096 0 4.548 4.548 0 0 0-9.096 0Z"
      fill="currentColor"
    />
  </svg>
</template>
